<template>
    <div v-if="sample">
        <v-tabs
                slot="extension"
                v-model="model"
                centered
                color="secondary"
                slider-color="primary"
                class="elevation-10"
        >
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-tab
                    href="#tab-order"
            >
                Order
            </v-tab>
            <v-tab
                    href="#tab-info"
            >
                Order info
            </v-tab>
            <v-tab
                    href="#tab-documents"
            >
                Sample request docs
            </v-tab>
            <v-tab
                    href="#tab-confirmation"
            >
                Shipment docs
            </v-tab>
            <v-spacer></v-spacer>
            <v-btn
                    :href="BASE + 'sample-order/' + id + '?download_token=' + download_token"
                    target="_blank"
            >
                Download sample request
            </v-btn>
            <v-btn
                    v-if="sample.status_id == 5"
                    @click="sendAmc()"
                    color="primary"
            >
                Send notitification to Laboratory
            </v-btn>
            <v-btn
                    v-if="sample.status_id == 3"
                    @click="sendClient()"
                    color="primary"
            >
                Change status to accepted and send
            </v-btn>
        </v-tabs>



        <v-tabs-items
                v-model="model"
                class="elevation-10"
        >
            <v-tab-item
                    value="tab-order"
                    lazy
                    :transition="false"
                    :reverse-transition="false"
            >
                <v-card flat>
                    <SampleOrderComponent :sample="sample" v-if="model == 'tab-order'" v-on:updated="getSampleOrderDetail()"></SampleOrderComponent>
                </v-card>
            </v-tab-item>
            <v-tab-item
                    value="tab-info"
                    lazy
                    :transition="false"
                    :reverse-transition="false"
            >
                <v-card flat>
                    <InfoComponent :sample="sample" v-if="model == 'tab-info'"></InfoComponent>
                </v-card>
            </v-tab-item>
            <v-tab-item
                    value="tab-documents"
                    lazy
                    :transition="false"
                    :reverse-transition="false"
            >
                <v-card flat>
                    <SampleRequestComponent :sample="sample" v-if="model == 'tab-documents'" :order_id="id"></SampleRequestComponent>
                </v-card>
            </v-tab-item>
            <v-tab-item
                    value="tab-confirmation"
                    lazy
                    :transition="false"
                    :reverse-transition="false"
            >
                <v-card flat>
                    <ShipmentComponent :sample="sample" v-if="model == 'tab-confirmation'" :order_id="id"></ShipmentComponent>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>

    import SampleOrderComponent from './views/SampleOrderComponent';
    import InfoComponent from './views/InfoComponent';
    import SampleRequestComponent from './views/SampleRequestComponent';
    import ShipmentComponent from './views/ShipmentComponent';
    import { BASE } from "../../../config";

    export default {
        props: ['id'],
        data () {
            return {
                model: 'tab-order',
                sample: null,
                comments: null,
                BASE: BASE,
                download_token: null
            }
        },
        created () {
            this.checkUser();
            this.setSectionTitle();
            this.getSampleOrderDetail();
            if (this.$route.query.model == 'tab-info') {
                this.model = 'tab-info';
            }
            if (this.$route.query.model == 'tab-documents') {
                this.model = 'tab-documents';
            }
        },
        methods: {
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.download_token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Sample request detail.'
                });
            },
            getSampleOrderDetail () {
                this.$store.dispatch('getSampleOrderDetail', {
                    id: this.id
                }).then((res) => {

                    this.sample = res.data.data;

                }).catch((error) => {

                });
            },
            sendAmc() {
                this.$store.dispatch('SampleOrderSendAmc', {
                    id: this.id
                }).then((res) => {

                    this.getSampleOrderDetail();

                }).catch((error) => {

                });
            },
            sendClient() {
                this.$store.dispatch('SampleOrderSendClient', {
                    id: this.id
                }).then((res) => {

                    this.getSampleOrderDetail();

                }).catch((error) => {

                });
            }
        },
        components: {
            SampleOrderComponent,
            InfoComponent,
            SampleRequestComponent,
            ShipmentComponent
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/samples/DetailComponent.vue